module.exports = __webpack_public_path__ + "d8445a8007c0f7de57a1c3c6feaf19c9.png";